export default __webpack_public_path__ + "images/fse+.png?c80eed9a";